var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoImagineNeutralHighMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 48,
    viewBox: "0 0 128 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 93.136,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 128,
    height: 48,
    transform: "translate(-11 -8)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(6 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.469,62.508h-.449a1.33,1.33,0,0,1-1.326-1.326v-.449a1.33,1.33,0,0,1,1.326-1.327h.449A1.33,1.33,0,0,1,62.8,60.733v.449a1.33,1.33,0,0,1-1.326,1.326",
    transform: "translate(-53.836 -53.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.406,0h-.252a.78.78,0,0,0-.778.778V3.95a.78.78,0,0,0,.778.778h.252a.78.78,0,0,0,.778-.778V.778A.78.78,0,0,0,67.406,0",
    transform: "translate(-59.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.154,107.152H61.34a1,1,0,0,0-1,1V118.7a1,1,0,0,0,1,1h.814a1,1,0,0,0,1-1V108.152a1,1,0,0,0-1-1",
    transform: "translate(-54.42 -96.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M635.385,62.508h-.449a1.331,1.331,0,0,1-1.327-1.326v-.449a1.331,1.331,0,0,1,1.327-1.327h.449a1.331,1.331,0,0,1,1.326,1.327v.449a1.331,1.331,0,0,1-1.326,1.326",
    transform: "translate(-571.445 -53.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M636.069,107.152h-.815a1,1,0,0,0-1,1V118.7a1,1,0,0,0,1,1h.815a1,1,0,0,0,1-1V108.152a1,1,0,0,0-1-1",
    transform: "translate(-572.027 -96.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M144.017,109.122v7.509a.884.884,0,0,1-.885.846h-1.123a.848.848,0,0,1-.846-.846V109.99a13.557,13.557,0,0,0-.087-1.528c-.078-.4-.5-1.061-1.658-1.061a3.263,3.263,0,0,0-2.435.915,2.531,2.531,0,0,0-.66,1.53l-.025,6.728a.9.9,0,0,1-.9.9h-1.01a.9.9,0,0,1-.9-.9l-.017-6.384a16.691,16.691,0,0,0-.087-1.728c-.079-.4-.5-1.061-1.657-1.061a3.264,3.264,0,0,0-2.436.915,2.139,2.139,0,0,0-.684,1.53v6.631a1,1,0,0,1-1,1h-.814a1,1,0,0,1-1-1V105.93a1.041,1.041,0,0,1,1.044-1h.569a1.073,1.073,0,0,1,1.012.571.692.692,0,0,0,.584.338c.3,0,.81-.439,1.417-.66a6.966,6.966,0,0,1,2.339-.49,4.119,4.119,0,0,1,2.855,1.333.517.517,0,0,0,.713.135,12.16,12.16,0,0,1,1.893-1.012,5.694,5.694,0,0,1,1.96-.429c.408,0,2.245-.041,3.117,1.169a6.088,6.088,0,0,1,.725,3.235",
    transform: "translate(-113.449 -94.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M701.428,108.577a2.311,2.311,0,0,0-.684,1.53v6.631a1,1,0,0,1-1,1h-.815a1,1,0,0,1-1-1V106.191a1.041,1.041,0,0,1,1.044-1h.569a1.073,1.073,0,0,1,1.011.571c.2.275.3.362.584.338a9.98,9.98,0,0,0,1.932-.694,6.166,6.166,0,0,1,1.961-.429c.408,0,2.245-.041,3.117,1.169a6.084,6.084,0,0,1,.725,3.235v7.509a.884.884,0,0,1-.885.846h-1.123a.848.848,0,0,1-.846-.846V110.25a13.571,13.571,0,0,0-.088-1.528,1.63,1.63,0,0,0-1.658-1.061,3.919,3.919,0,0,0-2.846.915",
    transform: "translate(-629.455 -94.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.061,20.756l-.178.178a.78.78,0,0,0,0,1.1l2.243,2.243a.78.78,0,0,0,1.1,0L20.4,24.1a.78.78,0,0,0,0-1.1l-2.243-2.243a.78.78,0,0,0-1.1,0",
    transform: "translate(-15.022 -18.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.183,20.756l.178.178a.78.78,0,0,1,0,1.1l-2.243,2.243a.78.78,0,0,1-1.1,0L93.84,24.1a.78.78,0,0,1,0-1.1l2.243-2.243a.78.78,0,0,1,1.1,0",
    transform: "translate(-84.429 -18.515)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M102.889,69.977v.252a.78.78,0,0,0,.778.778h3.172a.78.78,0,0,0,.778-.778v-.252a.78.78,0,0,0-.778-.778h-3.172a.78.78,0,0,0-.778.778",
    transform: "translate(-92.794 -62.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,69.977v.252a.78.78,0,0,0,.778.778H3.95a.78.78,0,0,0,.778-.778v-.252A.78.78,0,0,0,3.95,69.2H.778A.78.78,0,0,0,0,69.977",
    transform: "translate(0 -62.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M496.986,105.783c-.511-.944-4.815-1.091-4.815-1.093-1.766,0-3.574.41-4.491,1.324-2.23,1.841-1.522,8.3-.383,9.771.436.61,1.237,1.693,3.88,1.693,2.483,0,3.233-.956,3.233.37,0,.363,0,1.995-2.948,1.995-2.664,0-4.073-1.037-4.073,1.121,0,1.63,4.027,1.449,4.369,1.449a7.106,7.106,0,0,0,3.745-.785,3.475,3.475,0,0,0,1.715-2.787c.016-.113.029-.226.038-.338V106.486a1.05,1.05,0,0,0-.27-.7m-2.544,3.935v3.7c-.331,1.241-1.072,1.566-2.379,1.566a2.64,2.64,0,0,1-2.335-1.051c-.531-.709-.488-2.931-.488-3.463a4.92,4.92,0,0,1,.188-1.123A3.124,3.124,0,0,1,490.22,108a3.249,3.249,0,0,1,2.477-.9c1.033,0,1.745.569,1.745,1.114Z",
    transform: "translate(-438.519 -94.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M598.328,245.479a1.121,1.121,0,0,1-.038.338c.016-.113.029-.226.038-.338",
    transform: "translate(-539.591 -221.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M351.693,115.091c-.489-.205-.508-1.482-.508-1.482v-5c0-.852-.122-2.554-1.51-3.35a7.28,7.28,0,0,0-3.563-.7c-.342,0-4.667-.253-4.667,1.376,0,2.158,1.419,1,4.084,1,2.775,0,2.775,1.284,2.775,1.647,0,.883-.511.949-1.711.922a8.714,8.714,0,0,0-4.7.828,3.42,3.42,0,0,0-1.553,3.225,4.142,4.142,0,0,0,.946,3.075,3.5,3.5,0,0,0,2.571.827c2.666,0,3.973-1.38,4.514-1.261.786.172.737,1.143,1.871,1.143h1.009c.5,0,1.451-.111,1.451-1.152,0-.938-.355-.829-1.01-1.1m-3.507-1.625a3.881,3.881,0,0,1-3.162,1.625,1.84,1.84,0,0,1-1.411-.426,1.532,1.532,0,0,1-.324-1.123,1.672,1.672,0,0,1,.623-1.518c.395-.371,1.751-.371,3.46-.371.378,0,.672,0,.829.26a2.191,2.191,0,0,1-.016,1.553",
    transform: "translate(-306.949 -94.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M837.269,111.62c0,1.555.8,3.972,2.129,4.86a5.976,5.976,0,0,0,3.744.785c.342,0,4.369.18,4.369-1.45,0-2.158-1.418-1-4.083-1-2.775,0-2.989-1.738-2.989-2.1,0-1.284.2-1.058,1.678-1.058h3.1c1.77,0,2.475-.032,2.665-.284.408-.542.379-.879.379-2.018a6.021,6.021,0,0,0-1.514-3.627,5.51,5.51,0,0,0-3.681-1.356c-3.477,0-5.8,1.592-5.8,7.253m3.372-3.583a2.349,2.349,0,0,1,2.124-1.225,2.413,2.413,0,0,1,2.451,1.953,1.25,1.25,0,0,1-.377.9c-.394.371-1.579.331-3.289.331a1.057,1.057,0,0,1-.882-.419,1.633,1.633,0,0,1-.027-1.539",
    transform: "translate(-755.123 -94.127)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M598.68,232.3v1.293a5.3,5.3,0,0,0,0-1.293",
    transform: "translate(-539.943 -209.508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImagineNeutralHighMain);
export default __webpack_public_path__ + "static/media/logo-imagine_neutral-high-main.e259528060a61b5491c89ba39d40e271.svg";
export { ForwardRef as ReactComponent };